import './styles.scss';
import { useMemo } from 'react';
import { Link } from 'react-router-dom';

import ExchangeConnectImageSVG from '../../../assets/exchange-connect-image.svg';
import { PORTFOLIO_MESSAGES } from '../../../constants/reports/reports-messages';

interface PortfolioMessageHandlerProps {
  emptyCredentials?: boolean;
}

export const PortfolioMessageHandler = ({ emptyCredentials }: PortfolioMessageHandlerProps) => {
  const { SELECT_DATA_RISK, EMPTY_CREDENTIALS } = PORTFOLIO_MESSAGES;

  const renderEmptyCredentials = useMemo(() => {
    return (
      <div className="portfolio-no-credentials">
        <img src={ExchangeConnectImageSVG} alt="crypto" />
        <span className="title">{EMPTY_CREDENTIALS.title}</span>
        <Link className="connect-exchange-bt" to="/settings">
          {EMPTY_CREDENTIALS.button}
        </Link>
      </div>
    );
  }, []);

  if (emptyCredentials) {
    return renderEmptyCredentials;
  }

  return (
    <div className="portfolio-message-container">
      <span className="title">{SELECT_DATA_RISK.title}</span>
      <span className="message">{SELECT_DATA_RISK.description}</span>
    </div>
  );
};
